import React from 'react';
import {useTranslation} from "react-i18next";
import {Image} from "react-bootstrap";
import dashboardImage from "../../../assets/img/dashboard.webp";
import {Card} from "../common/Card";


export const SPFProtection = () => {
    const {t} = useTranslation();
    const items = (t("pages.protectionWithSpf.list", {returnObjects: true})) || [];
    const moreItems = (t("pages.protectionWithSpf.more.description.list", {returnObjects: true})) || [];

    return (
        <>
            <div className={"container "}>
                <div className="row align-items-center justify-content-between flex-column-reverse flex-lg-row py-5"
                     id={"hero"}>
                    <div className="col px-4 mb-4 mb-lg-0 text-center text-lg-start">
                        <h1>{t("pages.protectionWithSpf.title")}</h1>
                        <div className="mb-3">
                            {t("pages.protectionWithSpf.description")}
                        </div>
                        <div className={"mb-3"}>
                            <ul className="list-unstyled">
                                {Object.values(items).map((item, index) => (
                                    <li key={index} className="mb-2">
                                        • {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <button className="btn btn-primary text-white">
                            {t("pages.protectionWithSpf.cta")}
                        </button>
                    </div>
                    <div className="col px-4 d-flex justify-content-center">
                        <div
                            className="col-12 col-md-10 col-lg-8 d-flex align-items-center justify-content-center px-4">
                            <Image src={dashboardImage} alt={"dashboard"} className={"img-fluid"}></Image>
                        </div>

                    </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 py-5 justify-content-center" id="cards1">
                    <div className={"col"}>
                        <Card
                            title={t("pages.protectionWithSpf.cards.one.title")}
                            features={t("pages.protectionWithSpf.cards.one.features")}
                            iconClass={"bi bi-tv-fill text-primary"}
                        ></Card>
                    </div>
                    <div className={"col"}>
                        <Card
                            title={t("pages.protectionWithSpf.cards.two.title")}
                            features={t("pages.protectionWithSpf.cards.two.features")}
                            iconClass={"bi bi-tv-fill text-primary"}
                        ></Card>
                    </div>
                </div>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 py-5 justify-content-center" id="cards2">
                    <div className={"col"}>
                        <Card
                            title={t("pages.protectionWithSpf.cards.three.title")}
                            features={t("pages.protectionWithSpf.cards.three.features")}
                            iconClass={"bi bi-tv-fill text-primary"}
                        > < /Card>
                    </div>
                    <div className={"col"}>
                        <Card
                            title={t("pages.protectionWithSpf.cards.four.title")}
                            features={t("pages.protectionWithSpf.cards.four.features")}
                            iconClass={"bi bi-tv-fill text-primary"}
                        > < /Card>
                    </div>
                </div>

                <div className="row py-5 px-4 text-center text-lg-start" id="moreDescription">
                    <div className="col mx-auto" style={{maxWidth: "900px"}}>
                        <h2>{t("pages.protectionWithSpf.more.title")}</h2>
                        <div className="mb-3">

                            <div className={"container"}>
                                {Object.values(moreItems).map((item, index) => (
                                    <div key={index} className={"row mb-3"}>
                                        <div className={"col"}>
                                            <h4>{item.title}</h4>
                                            <span>{item.description}</span>
                                        </div>
                                    </div>

                                ))}
                            </div>

                        </div>
                        <button className="btn btn-secondary text-white">
                            {t("pages.protectionWithSpf.more.cta")}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
};
